import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '@/lib/i18n';

export const Footer = () => {
  const { t } = useT();
  return (
    <footer className="border-t border-white/5 mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid grid-cols-2 md:grid-cols-6 gap-8 text-sm">
        <div className="col-span-2 md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <img src="/logo.png" alt="HighlightAI logo" className="w-9 h-9 object-contain" data-testid="footer-logo-img" />
            <span className="font-heading text-xl font-black">HighlightAI</span>
          </div>
          <p className="text-zinc-500 max-w-sm">{t('footer.tagline')}</p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">{t('footer.product')}</h4>
          <ul className="space-y-2 text-zinc-300">
            <li><a href="/#features" className="hover:text-[#D4FF00]">{t('nav.features')}</a></li>
            <li><Link to="/pricing" className="hover:text-[#D4FF00]">{t('nav.pricing')}</Link></li>
            <li><Link to="/register" className="hover:text-[#D4FF00]">{t('nav.signup')}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">{t('footer.compare')}</h4>
          <ul className="space-y-2 text-zinc-300">
            <li>vs Opus Clip</li>
            <li>vs Captions</li>
            <li>vs Klap</li>
            <li>vs Vidyo.ai</li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">{t('footer.support')}</h4>
          <a
            href="mailto:contact@highlightai.online"
            className="text-zinc-300 hover:text-[#D4FF00] break-all font-mono text-xs"
            data-testid="footer-support-email"
          >
            contact@highlightai.online
          </a>
          <p className="text-zinc-600 text-xs mt-2 leading-relaxed">{t('footer.support.help')}</p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Légal</h4>
          <ul className="space-y-2 text-zinc-300">
            <li><Link to="/legal/mentions" className="hover:text-[#D4FF00]" data-testid="footer-mentions">Mentions légales</Link></li>
            <li><Link to="/legal/cgv" className="hover:text-[#D4FF00]" data-testid="footer-cgv">CGV/CGU</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-[#D4FF00]" data-testid="footer-privacy">Confidentialité</Link></li>
            <li><Link to="/legal/cookies" className="hover:text-[#D4FF00]" data-testid="footer-cookies">Cookies</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-zinc-600">{t('footer.copy')}</div>
    </footer>
  );
};

export default Footer;
